export default "__VITE_ASSET__f4aa71aa__"